'use strict'; // eslint-disable-next-line no-extra-parens, no-empty-function

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var cached =
/** @type {import('.').AsyncFunctionConstructor} */

/*#__PURE__*/
_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
})).constructor;
/** @type {import('.')} */


module.exports = function () {
  return cached;
};